<template>
  <div class="chart-content">
    <Chart
      :labels="label"
      :series="chartData"
      type="doughnut"
      :inner-text="`${data[0]}%`"
      :options="doughnutOptions"
      size="small"
    >
      <template #tooltip>
        <ComparisonTooltip
          :point="currentPoint"
          :metric="tooltipHeader"
          :format-value="formatValue"
          :cumulative="false"
          type="percentage"
        />
      </template>
    </Chart>
  </div>
</template>

<script>
import { mapState } from "vuex";

import ComparisonTooltip from "@/components/Chart/ComparisonTooltip.vue";
import Chart from "../../components/Chart/Chart.vue";

export default {
  components: {
    Chart,
    ComparisonTooltip
  },
  props: {
    header: {
      type: String,
      default: null
    },
    base: {
      type: Object,
      default: null
    },
    comparison: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      label: null,
      data: [0, 0],
      chartData: [],
      doughnutOptions: {
        legend: {
          display: false
        }
      }
    };
  },
  computed: {
    ...mapState(["dashboardFilters"]),
    currentPoint() {
      const base = { ...this.base, date: this.dashboardFilters.base_range };
      const comparison = {
        ...this.comparison,
        date: this.dashboardFilters.comparison_range
      };
      return {
        base,
        comparison
      };
    },
    tooltipHeader() {
      return this.capitalize(this.header.toLowerCase());
    }
  },
  watch: {
    base(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getChartData();
      }
    }
  },
  mounted() {
    this.getChartData();
  },
  methods: {
    formatValue(value) {
      return this.formatPercent(value);
    },
    getChartData() {
      this.label = ["Closed", "Not Closed"];
      const first = parseInt(this.base.value * 100, 10);
      const second = 100 - first;
      this.data = [first, second];
      this.chartData = [
        {
          fill: false,
          data: this.data,
          borderColor: "#FFF"
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.chart-content {
  width: 150px;
  height: 75px;
}
</style>
